import React from 'react'

import {Text} from '@vio/atlas/Text'
import {CancellationPenalty} from '@vio/core/src/offer/types/offer'
import {
  getDisplayPrice,
  getPriceCurrencyCode,
  getTotalPrice,
  Price
} from '@vio/core/src/price/business/price'
import {CancellationPenalties} from '@vio/shared/src/booking/CancellationPenalties'
import {usePointsPriceDisplay} from '@vio/shared/src/whiteLabel/hooks/usePointsPriceDisplay'
import {PointsPriceText} from '@vio/shared/src/whiteLabel/PointsPrice'

interface DealDetailsCancellationProps {
  cancellationPenalties: CancellationPenalty[]
  prices: Price[]
  hotelTimeZone?: string
}

export const DealDetailsCancellation = ({
  cancellationPenalties,
  prices,
  hotelTimeZone
}: DealDetailsCancellationProps) => {
  const displayPrice = getDisplayPrice(prices)
  const totalPrice = getTotalPrice(displayPrice)
  const currencyCode = getPriceCurrencyCode(displayPrice)
  const points = usePointsPriceDisplay()

  return (
    <CancellationPenalties
      cancellationPenalties={cancellationPenalties}
      totalPrice={totalPrice}
      displayCurrencyCode={currencyCode}
      hotelTimeZone={hotelTimeZone}
      renderTotalPrice={
        points.isOn
          ? (value, currencyCode) => (
              <Text variant="bodyM">
                <PointsPriceText
                  {...points.splitParts(value)}
                  currencyCode={currencyCode}
                />
              </Text>
            )
          : undefined
      }
    />
  )
}
